(function () {'use strict';}());
angular.module("elidb").directive('detailMap', function($document,$timeout) {
    return {
      restrict: 'A',

      link:function($scope,element,attr)
      {
        var trace = angular.trace; 
        var openWindow;

        $scope.$watch("detailView",initialize);

        function initialize(val)
        {
        	if(!val) return;
        	if(!window.google) return trace("no google map library found");

        	$timeout(function(){
        		var position = {lat: val.latitude, lng: val.longitude};
				var map = new google.maps.Map(element.find("div[class='map-column']")[0], {
					zoom: 10,
					center: position
				});
					
				var infowindow = new google.maps.InfoWindow({
				    content: val.name
				  });

				var marker = new google.maps.Marker({
					position: position,
					map: map,
					title: val.name
				});

				marker.addListener('click', function() {
					if(openWindow) openWindow.close();
					openWindow = infowindow;
				    infowindow.open(map, marker);
				  });
        	},0);
        	
			
			
        }
      }  
    };
  });